import { LOGIN } from './types';

export function userLogin(payload, cb) {
  return {
    type: LOGIN,
    payload,
    cb,
  };
}
